/* eslint-disable */
import React from 'react';
import { BoundariesLayerItem } from './BoundariesLayerItem';
import { AccordionSection } from 'mapcontrols/components/subComponents';

const BoundariesSection = ({
  calculableBoundaryLayers = [],
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeSections = {},
  onSectionToggle = () => {},
  calcPolygonSelections = [],
  calcPolygonLabelSelections = [],
  onCalculablePolygonChange = () => {},
  onCalculablePolygonLabelChange = () => {},
  inspectionFailureRateSelection = null,
}) => {
  const isBoundaryDisabled = (boundaryValue) => {
    return (
      inspectionFailureRateSelection &&
      inspectionFailureRateSelection.activeLayer !== 'no_inspection_failure_rate' &&
      inspectionFailureRateSelection.polytype === boundaryValue
    );
  };
  return (
    <AccordionSection
      title="Boundaries"
      id="otherbounds"
      activeSections={activeSections}
      onSectionToggle={onSectionToggle}
      collapsedArrowIcon={collapsedArrowIcon}
      expandedArrowIcon={expandedArrowIcon}
    >
      {calculableBoundaryLayers.map((layerinfo, index) => {
        return (
          <BoundariesLayerItem
            key={index}
            layerId={layerinfo.slug}
            swatchStyle={{ backgroundColor: layerinfo.bordercolor }}
            swatchType="line"
            stackingOrder="100"
            label={layerinfo.plural}
            hasLabels
            disabled={isBoundaryDisabled(layerinfo.slug)}
            calcpolyLayerId={`calcpoly-${layerinfo.slug}`}
            onCalculablePolygonChange={onCalculablePolygonChange}
            onCalculablePolygonLabelChange={onCalculablePolygonLabelChange}
            calcPolygonSelections={calcPolygonSelections}
            calcPolygonLabelSelections={calcPolygonLabelSelections}
          />
        );
      })}
    </AccordionSection>
  );
};

export default BoundariesSection;
